import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionRadioComponent } from './question-radio.component';
import { DndModule } from 'ngx-drag-drop';
import { OptionNumberModule, OptionTextModule } from '../../options';

@NgModule({
  imports: [
    QuestionModule,
    DndModule,
    OptionNumberModule, OptionTextModule,
  ],
  declarations:[QuestionRadioComponent],
  exports:[QuestionRadioComponent],
})
export class QuestionRadioModule { }

